// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FunctionOperatorTab.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * FunctionOperatorTab component
 */
import React from 'react';
import { observer } from 'mobx-react';
import Panel from 'share/components/controls/Izenda.Panel';
import Label from 'share/components/controls/Izenda.Label';
import { Table, Column } from 'share/components/controls/DataGrid/Izenda.Table';
import CalculatedFieldConstants from 'logic/data/Izenda.CalculatedFieldConstants';
import { partial } from 'lodash/fp';
const constants = CalculatedFieldConstants.FUNCTION_OPERATOR;
const TABLE_DEF = CalculatedFieldConstants.TABLE_DEFINITION.FunctionOperator;

@observer
class FunctionOperatorTab extends React.Component {
  static displayName = 'FunctionOperatorTab';
  static propTypes = {
    store: React.PropTypes.object.isRequired
  };

  render() {
    let {
      store: { functionOperators, pageInfo }
    } = this.props;

    return (
      <div className="expression-tab">
        <Label className="col-md-12 instruction">{constants.instruction}</Label>

        <Table dataSource={functionOperators} onSortChange={this.onSortChange} sortInfo={pageInfo.colSortDirs}>
          {/* Function name */}
          <Column {...TABLE_DEF['name']} cell={this.renderName} />

          {/* Syntax */}
          <Column {...TABLE_DEF['syntax']} cell={this.renderSyntax} />
        </Table>
      </div>
    );
  }

  /**
   * Render name column
   * @param {Object} detail
   */
  renderName = (detail: Object) => {
    return (
      <span
        className="selectable truncate overflow-text"
        title={detail.name}
        onMouseDown={partial(this.onSelect, [detail])}
      >
        {detail.name}
      </span>
    );
  };

  /**
   * Render syntax column
   * @param {Object} detail
   */
  renderSyntax = (detail: Object) => {
    return <span>{detail.syntax}</span>;
  };

  /**
   * Handle on sort change of column.
   * @param {String} columnKey
   * @param {String} sortDir
   */
  onSortChange = (columnKey: String, sortDir: String) => {
    this.props.store.pageInfo.setColSortDirs(columnKey, sortDir);
    this.props.store.sort();
  };

  /**
   * Handle on select.
   * @param {Object} detail
   */
  onSelect = (detail: Object) => {
    const onSelect = this.props.onSelect;

    onSelect && onSelect(detail.expressionSyntax);
  };
}

export default FunctionOperatorTab;



// WEBPACK FOOTER //
// ./ui/share/components/controls/calculatedField/Izenda.FunctionOperatorTab.js